import { render, staticRenderFns } from "./PromotionLookup.vue?vue&type=template&id=6ee2bc1a&lang=pug"
import script from "./PromotionLookup.vue?vue&type=script&lang=js"
export * from "./PromotionLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports